<template>
  <div class="appointment-record-view">
    <ph-tabs
      v-if="qrtype !== '2'"
      v-model="active"
      :list="[
        { name: '有卡查询', id: '0' },
        { name: '无卡查询', id: '1' },
      ]"
      @tabClick="tabChange"
    />
    <!-- 日期选择 -->
    <DateSelectorView @dateSelected="confirmPicker" />
    <!-- 无卡预约操作 -->
    <div v-if="active === '1'">
      <div v-show="showNocardBtn" @click="requeryClick" class="no-card-btn">
        点击重新输入查询
      </div>
      <div
        v-show="!showNocardBtn"
        class="nocardview"
        style="margin: 30% 5% 0 5%"
      >
        <van-cell-group>
          <van-field
            v-model="patientName"
            label="姓名"
            placeholder="请输入用姓名"
          />
          <van-field
            v-model="idcradNum"
            label="身份证"
            placeholder="请输入用身份证"
          />
        </van-cell-group>
        <ph-button
          @click="noCardClick"
          title="立即查询"
          style="margin-top: 2rem"
        />
      </div>
    </div>

    <div>
      <ph-empty v-if="active === '0' && !getList.length" bgcolor="white" />
      <div v-for="(item, index) in getList" :key="index" class="record-list">
        <!-- <img v-lazy="item.photourl" alt="" /> -->
        <van-image :src="item.photourl" class="doctor-protrait" alt="">
          <img slot="error" :src="require('@assets/ic_doctor.png')" alt="" />
        </van-image>
        <div class="appointment-view">
          <div style="color: #393c4b">
            {{ item.appointmentDate }} {{ item.appointmentTime }}
          </div>
          <div>
            {{ item.appointDoctorName }}
          </div>
          <div>
            {{ item.appointOfficeName }}
          </div>
        </div>
        <div class="status-view">
          <div v-if="item.appointmentState == 0" style="color: #f4333c">
            已登记
          </div>
          <div v-if="item.appointmentState == 1" style="color: #999">
            已确认
          </div>
          <div v-if="item.appointmentState == 3" style="color: #108eee">
            已就诊
          </div>
          <div style="color: #393c4b">{{ item.waitNumber }}号</div>
          <button
            v-show="item.appointmentState == 0 || item.appointmentState == 1"
            @click="cancleClick(item)"
          >
            取消预约
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import DateSelectorView from "./DateSelectorView";

export default {
  components: {
    DateSelectorView,
  },
  data() {
    return {
      ftype: "1",
      active: "0",
      list: [],
      showStart: false,
      showEnd: false,
      clickIndex: "",
      startDate: new Date(),
      endDate: new Date(),
      tabClickIndex: "0",
      nocardList: [],
      showNocardView: false,
      patientName: "",
      idcradNum: "",
      qrtype: "1",
      cardNo: "",
    };
  },
  computed: {
    getList() {
      if (this.active === "0") {
        return this.list;
      }
      return this.nocardList;
    },
    showNocardBtn() {
      return this.nocardList.length;
    },
    getStartDate() {
      return this.startDate
        ? this.$moment(this.startDate).format("YYYY年MM月DD日")
        : "";
    },
    getEndDate() {
      return this.endDate
        ? this.$moment(this.endDate).format("YYYY年MM月DD日")
        : "";
    },
  },
  created() {
    this.startDate = this.$moment().add(-1, "month").toDate();
    this.endDate = this.$moment().add(1, "month").toDate();
    this.qrtype = this.$route.query.qrtype || "1";
    this.ftype = this.$route.query.ftype || "1";
    if (this.$route.query.appointmentType === "2") {
      this.active = this.$route.query.appointmentType === "2" ? "1" : "0";
      this.patientName = this.$route.query.name;
      this.idcradNum = this.$route.query.idCard;
      this.showNocardView = true;
      this.noCardClick();
      return;
    }

    if (this.qrtype === "1") {
      this.getRecordList();
    } else {
      this.getUserBaseQrcodeInfo().then((res) => {
        this.patientName = res.patientName || res.name;
        this.cardNo = res.cardNo;
        this.idcradNum = res.idCard;
        this.getQrRecordList();
      });
    }
  },
  methods: {
    ...mapActions("users", ["getUserBaseQrcodeInfo"]),
    // 点击取消
    cancleClick(item) {
      this.$dialog
        .confirm({
          title: "取消预约",
          message: "是否确认取消预约",
        })
        .then(() => {
          this.$http
            .post(this.$api.APPOINTMENT_CANCEL, {
              functionType: "1",
              ...item,
            })
            .then((res) => {
              this.$toast(res.result);
              if (this.active === "0") {
                this.getRecordList();
              } else {
                this.noCardClick();
              }
            });
        })
        .catch(() => {});
    },
    // 显示弹窗
    showPopup(index) {
      this.show = true;
      this.clickIndex = index;
    },
    getAppointmentDate(time) {
      return this.$moment(time).format("YYYY-MM-DD");
    },
    // 确认选择的时间
    confirmPicker(selStartDate, SelendDate) {
      this.startDate = selStartDate;
      this.endDate = SelendDate;
      if (this.active === "0") {
        this.getRecordList();
      }
    },
    // 无卡重新输入查询
    requeryClick() {
      this.showNocardView = true;
      this.nocardList = [];
    },
    // 无卡记录查询按钮
    noCardClick() {
      if (!this.patientName || !this.idcradNum) {
        alert("请输入预约时填写的身份证及姓名进行查询");
        return;
      }

      this.$http
        .post(this.$api.USER_BASE_INFO, {
          functionType: "1",
        })
        .then((res) => {
          // if (res.idCard != this.idcradNum) {
          //   alert("当前输入的身份证号码与绑定卡的身份证号不匹配");
          //   return;
          // }
          this.$http
            .post(this.$api.APPOINTMENT_RECORD, {
              name: this.patientName,
              idCard: this.idcradNum,
              startDate: this.$moment(this.startDate).format("YYYYMMDD"),
              endDate: this.$moment(this.endDate).format("YYYYMMDD"),
              functionType: "1",
              flag: "1",
            })
            .then((res) => {
              this.nocardList = res;
              if (this.nocardList <= 0) {
                this.$toast("暂无预约记录");
              }
              this.showNocardView = false;
            });
        })
        .catch(() => {
          // this.appointmentType = "2";
          this.alert("请先绑卡");
          // this.router.replace({
          //   name: "relative-card"
          // });
        });
    },
    // tabs切换
    tabChange(_, name) {
      console.log("name", name);
      // this.patientName = "";
      // this.idcradNum = "";
      // this.cardNo = "";
      if (name === "1") {
        if (this.nocardList.length <= 0) {
          this.list = [];
          this.showNocardView = true;
        }
      } else {
        this.showNocardView = false;
        this.getRecordList();
      }
    },
    // 有卡获取预约记录
    getRecordList() {
      this.$http
        .post(this.$api.APPOINTMENT_RECORD, {
          name: this.patientName || null,
          idCard: this.idcradNum || null,
          cardNo: this.cardNo || null,
          tjFlag: this.ftype === "3" ? "1" : null,
          startDate: this.$moment(this.startDate).format("YYYYMMDD"),
          endDate: this.$moment(this.endDate).format("YYYYMMDD"),
          functionType: "1",
          flag: "0",
        })
        .then((res) => {
          this.list = res;
        })
        .catch(() => {
          this.list = [];
        });
    },
    // 三码预约记录
    getQrRecordList() {
      this.$http
        .post(this.$api.APPOINTMENT_RECORD, {
          name: this.patientName || null,
          idCard: this.idcradNum || null,
          cardNo: this.cardNo || null,
          startDate: this.$moment(this.startDate).format("YYYYMMDD"),
          endDate: this.$moment(this.endDate).format("YYYYMMDD"),
          functionType: "1",
          flag: "2",
        })
        .then((res) => {
          this.list = res;
        });
    },
  },
};
</script>

<style lang="less">
.appointment-record-view {
  margin-top: 10px;
  overflow: scroll;
  font-size: 0.81rem;
  background-color: white;

  .date-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 2.38rem;
    margin: 12px 15px 0 15px;
    padding: 0 0.88rem;
    line-height: 2.38rem;
    border: solid 1px #aaa;
    border-radius: 4px;
  }

  .no-card-btn {
    margin: 10px 10px 0 0;
    font-style: italic;
    text-align: right;
    text-decoration: underline;
  }

  .query-no-card-button {
    width: 100%;
    margin-top: 2rem;
  }

  .record-list {
    display: flex;
    margin: 10px;
    // margin-top: .75rem;
    border: solid #f2f2f2 1px;
    border-radius: 4px;

    .doctor-protrait {
      width: 3rem;
      height: 3rem;
      margin: auto 0.94rem;
    }

    .appointment-view {
      padding-top: 0.88rem;
      color: gray;
      font-weight: 500;
      line-height: 1.4rem;
    }

    .status-view {
      margin-top: 0.88rem;
      margin-right: 0.88rem;
      margin-left: auto;
      font-weight: bold;
      line-height: 1.4rem;
      text-align: center;

      button {
        margin-bottom: 0.75rem;
        padding: 3px 8px;
        color: #fff;
        font-size: 0.81rem;
        background-color: #108eee;
        border: none;
        border-radius: 4px;
      }
    }
  }
  .nocardview {
    .van-cell {
      font-size: 0.9rem;
      line-height: 2rem;
    }
  }
}
</style>
